import React from 'react'
import { Navigate } from 'react-router'

const ProtectedRoute = ({element}) => {

  const user = sessionStorage.getItem('checkUser');

  return (
    user ? element : <Navigate to='/' replace/>
  )
}

export default ProtectedRoute